import { makeStyles, Skeleton, SkeletonItem, SkeletonItemProps, tokens } from '@fluentui/react-components';
import * as React from 'react';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0',
    padding: '2px',
  },
  tabContentContainer: {
    paddingInline: tokens.spacingHorizontalXXL,
    paddingBlock: tokens.spacingVerticalXXL,
    display: 'flex',
    flexDirection: 'column',
    gap: '26px',
  },
  checkboxStyles: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '2px',
  },
});

export const MainScreenSkeleton = () => {
  const styles = useStyles();

  return (
    <Skeleton>
      <div className={styles.wrapper}>
        <TabListSkeleton tabWidths={[40, 85, 85]} />
        <div className={styles.tabContentContainer}>
          <FieldSkeleton />
          <FieldSkeleton fieldSize={56} />
          <CheckboxSkeleton />
          <SkeletonItem size={40} />
        </div>
      </div>
    </Skeleton>
  );
};

const useCheckboxStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '2px',
  },
  checkbox: {
    padding: '6px',
  },
  label: {
    width: '150px',
  },
});

const CheckboxSkeleton = () => {
  const styles = useCheckboxStyles();

  return (
    <div className={styles.wrapper}>
      <div className={styles.checkbox}>
        <SkeletonItem
          shape="square"
          size={16}
        />
      </div>
      <SkeletonItem
        size={16}
        className={styles.label}
      />
    </div>
  );
};

interface TabListSkeletonProps {
  tabWidths: number[];
}

const useTabListSkeletonStyles = makeStyles({
  container: {
    display: 'flex',
    gap: '20px',
    paddingBlock: '10px',
    paddingInline: '10px',
    maxWidth: '90%',
    backgroundColor: 'white',
  },
});

const TabListSkeleton = ({ tabWidths }: TabListSkeletonProps) => {
  const styles = useTabListSkeletonStyles();

  return (
    <div className={styles.container}>
      {tabWidths.map((width, i) => (
        <div
          key={i}
          style={{ width: `${width}px` }}
        >
          <SkeletonItem size={24} />
        </div>
      ))}
    </div>
  );
};

interface FieldSkeletonProps {
  fieldSize?: SkeletonItemProps['size'];
}

const useFieldSkeletonStyles = makeStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    width: '100px',
  },
});

const FieldSkeleton = ({ fieldSize = 32 }: FieldSkeletonProps) => {
  const styles = useFieldSkeletonStyles();
  return (
    <div className={styles.wrapper}>
      <SkeletonItem
        className={styles.label}
        size={16}
      />
      <SkeletonItem size={fieldSize} />
    </div>
  );
};
